module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "export ml-auto"
  }, [_c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "relative",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "ico-export icon largest"
  }), _vm._v(" "), (_vm.isVisible) ? _c('ul', {
    staticClass: "floating-menu bottom centered"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.printTo('pdf')
      }
    }
  }, [_vm._v("\n                Export PDF\n            ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.printTo('xls')
      }
    }
  }, [_vm._v("\n                Export XLS\n            ")])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "mailto:transport@algarexperience.pt"
    }
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "printer"
  }, [_c('span', {
    staticClass: "ico-print icon largest"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-10a6deca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a6deca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Export.vue
// module id = 3031
// module chunks = 0